import {toast} from 'react-toastify';
import {observer} from 'mobx-react-lite';
import React, {FC, useState} from 'react';
import {disableMFA, VerdocsEndpoint} from '@verdocs/js-sdk';
import {Button, Input, Label} from '../Components';
import {Dialog} from './Dialog';

interface DisableMFADialogProps {
  onClose: () => void;
  onDisabled: () => void;
}

/**
 * Turning the second factor off needs a code, so knowing the password alone is not enough. A backup
 * code works here too, for the case where the authenticator is the thing that was lost.
 */
export const DisableMFADialog: FC<DisableMFADialogProps> = observer(({onClose, onDisabled}) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [working, setWorking] = useState(false);

  const trimmed = code.trim();
  const valid = /^\d{6}$/.test(trimmed) || /^[a-z0-9]{4}-?[a-z0-9]{4}$/i.test(trimmed);

  const handleDisable = () => {
    setWorking(true);
    setError('');
    disableMFA(VerdocsEndpoint.getDefault(), trimmed)
      .then(() => {
        setWorking(false);
        toast.success('Multi-factor authentication is off.');
        onDisabled();
      })
      .catch((e) => {
        setWorking(false);
        setError(e.response?.data?.error || 'That code was not accepted.');
      });
  };

  return (
    <Dialog onCancel={onClose}>
      <div className="overflow-y-auto">
        <div className="mb-1 text-lg font-medium text-[#33364b]">Turn off multi-factor authentication</div>
        {/* <div className="mb-4 text-[13px] text-gray-500">Your account goes back to password only.</div> */}

        <div className="mb-4 flex flex-col gap-2">
          <Label>Code from your authenticator app, or a backup code</Label>
          <Input
            value={code}
            autoFocus
            placeholder="123456"
            className="w-48 font-mono"
            onChange={(e) => setCode(e.target.value.slice(0, 20))}
          />
          {/* <div className="text-[12px] text-gray-500">A backup code is used up either way.</div> */}
          {error && <div className="text-[12px] text-[#bb2e3e]">{error}</div>}
        </div>

        <div className="text-[12px] text-gray-500">
          If you have lost access to both your authenticator and backup codes, please contact your organization's
          administrator, or <a href="mailto:support@verdocs.com">support@verdocs.com</a>.
        </div>

        <div className="mt-5 flex justify-end gap-2">
          <Button variant="secondary" label="Keep it on" onClick={onClose} />
          <Button label="Turn off" disabled={working || !valid} onClick={handleDisable} />
        </div>
      </div>
    </Dialog>
  );
});
